import UploadImageButton from './UploadImageButton'

export default UploadImageButton
